import Resource from "./resource";

export class RootResource extends Resource {
    Application: string;
    Version: string;
    ApiVersion: string;
    InstallationId: string;
    ExtensionsCSS: string[];
    ExtensionsJavascript: string[];
    ExtensionAngularModules: string[];
    IsEarlyAccessProgram: boolean;
}

export default RootResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/rootResource.ts